import { FINISHED } from "./constants";

export const resultsFunction = () => FINISHED;
